import { scopeToBase } from '../PeriodTabs/periodTabs';

/**
 * Publication years as the periods of a listing.
 *
 * Everything keys off `publication_year`, never the effective date. The two
 * disagree on 17 of the 505 publications here - several old papers carry an
 * effective date from the day they were imported - so a date range would
 * quietly return a different set from the one the tabs describe.
 */

const FIELD = 'publication_year';
const ANY = 'plone.app.querystring.operation.selection.any';

/**
 * Years to consider, newest first: the ones the block's query names, or
 * otherwise the site's list of publication years. A person's page, say, names
 * none - the bar is however long their record happens to be.
 */
const periods = (querystring, vocabulary = []) => {
  const criterion = (querystring?.query || []).find(
    (c) => c.i === FIELD && Array.isArray(c.v) && c.v.length,
  );
  const years = criterion ? criterion.v : vocabulary;
  return [...new Set(years.map(String))].sort().reverse();
};

const narrow = (querystring, selection) => ({
  ...querystring,
  query: [
    ...(querystring.query || []).filter((c) => c.i !== FIELD),
    { i: FIELD, o: ANY, v: selection.map(String) },
  ],
});

/**
 * On a year page the path already pins the year down, and the year criterion
 * is there only to say which years the bar should offer - which on the older
 * pages is a different set entirely. Left in, it would filter the listing
 * down to nothing.
 */
const withoutPeriod = (querystring) => ({
  ...querystring,
  query: (querystring.query || []).filter((c) => c.i !== FIELD),
});

export const publicationYearSpec = {
  name: 'publicationYears',
  // `?pubyear=` is what links to these pages already carry.
  param: 'pubyear',
  navLabel: 'Publication years',
  noun: 'publications',
  vocabulary: 'academic.years_of_publication',
  periods,
  narrow,
  scope: scopeToBase,
  withoutPeriod,
  of: (item) => String(item[FIELD] ?? ''),
  label: (year) => year,
  segment: (year) => year,
  period: (segment) => (/^\d{4}$/.test(segment) ? segment : null),
  compare: (a, b) => a.localeCompare(b),
};

/**
 * The block settings under the names this variation stored them before it
 * shared the period-tabs listing. Blocks keep their data; it is read here.
 */
export const asPeriodTabsSettings = (data = {}) => ({
  ...data,
  tab_count: data.year_tabs_count,
  tab_pages_base: data.year_pages_base,
  trailing_link_label: data.older_link_label || 'Older Publications',
  trailing_link_url: data.older_link_url,
});

export default publicationYearSpec;
